import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    playheadSync: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label to sync Frame.io and Premiere playheads */
            playheadSync: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PremierePlayheadSyncButton.playheadSync?c=1h4dsv1yz2qo", defaultMessage: "Sync Playhead with Timeline" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
